export enum GenericAddStepOneModelEnum {
    RECOMMENDATION = "recommendation",
    QUOTE = "quote",
    RECOMMENDATION_COPY = "recommendation-copy",
    QUOTE_COPY = "quote-copy",
    EQUIPMENT = "equipment"
}
